import { Col, Divider, Row, Steps } from 'antd'
import CustomTag from 'components/CustomTag'
import EmptyCircle from 'components/icons/EmptyCircle'
import StepRejected from 'components/icons/StepRejected'
import StepsCompleted from 'components/icons/StepsCompleted'
import StepsIcon from 'components/icons/StepsIcon'
import React from 'react'
import styled from 'styled-components'
const { Step } = Steps

const StyledStep = styled(Step)`
  .ant-steps-item-title {
    width: 100% !important;
  }
`
const StyledDivider = styled(Divider)`
  margin: 5px;
`
const StyleRow = styled(Row)`
  padding: 10px;
  width: 500px;
`

const StyleDiv = styled.div`
  float: right;
  padding: 5px;
`
const iconCheck = value => {
  if (value === 'SCHEDULED') {
    return <StepsIcon />
  }
  if (value === 'SHORTLISTED') {
    return <StepsIcon />
  }
  if (value === 'SELECTED') {
    return <StepsCompleted />
  }
  if (value === 'REJECTED') {
    return <StepRejected />
  }
}

const CustomSteps = ({
  steps,
  direction = 'vertical',
  size = 'small',
  current,
  currentStatus,
  selectedStudent,
  ...props
}) => {
  const titleCheck = title => {
    if (selectedStudent?.status === 'SHORTLISTED') {
      return (
        <CustomTag
          message={selectedStudent?.status}
          bordered={true}
          background="#DFF0EA"
          colorType="#5DB594"
          border="#DFF0EA"
        />
      )
    }
    if (selectedStudent?.status === 'SCHEDULED') {
      return (
        <CustomTag
          message={selectedStudent?.status}
          bordered={true}
          background="#DFF0EA"
          colorType="#5DB594"
          border="#DFF0EA"
        />
      )
    }
    if (selectedStudent?.status === 'SELECTED') {
      return (
        <CustomTag
          message={
            selectedStudent?.offerStatus === 'NOT_RELEASED'
              ? 'Selected'
              : selectedStudent?.offerStatus === 'RELEASED'
              ? 'Offer Released'
              : selectedStudent?.offerStatus === 'ACCEPTED'
              ? 'Offer Accepted'
              : 'Offer Rejected'
          }
          bordered={true}
          background={
            selectedStudent?.offerStatus === 'REJECTED' ? '#FDF2F1' : '#DFF0EA'
          }
          colorType={
            selectedStudent?.offerStatus === 'REJECTED' ? '#E97E73' : '#5DB594'
          }
          border={
            selectedStudent?.offerStatus === 'REJECTED' ? '#FDF2F1' : '#DFF0EA'
          }
        />
      )
    }
    if (selectedStudent?.status === 'REJECTED') {
      return (
        <CustomTag
          message={selectedStudent?.status}
          bordered={true}
          background="#FDF2F1"
          colorType="#E97E73"
          border="#FDF2F1"
        />
      )
    }
    if (selectedStudent?.status === 'HOLD') {
      return (
        <CustomTag
          message={title}
          bordered={true}
          background="#FEF8F3"
          colorType="#F3A66E"
          border="#FEF8F3"
        />
      )
    }
  }

  return (
    <Steps direction={direction} size={size} current={current} {...props}>
      {steps?.map((step, index) => (
        <StyledStep
          key={index + 'steps'}
          icon={
            current > step?.activeKey ? (
              <StepsCompleted />
            ) : step?.activeKey == current ? (
              iconCheck(currentStatus)
            ) : (
              <EmptyCircle />
            )
          }
          title={
            <StyleRow>
              <Col span={12}>
                <div>{step.roundNumber}</div>
                <div>{step.roundName}</div>
              </Col>
              <Col span={12}>
                <StyleDiv>
                  {current > step?.activeKey ? (
                    <CustomTag
                      message={currentStatus}
                      bordered={true}
                      background="#DFF0EA"
                      colorType="#5DB594"
                      border="#DFF0EA"
                    />
                  ) : step?.activeKey == current ? (
                    titleCheck(currentStatus)
                  ) : null}
                </StyleDiv>
              </Col>
              <StyledDivider />
            </StyleRow>
          }
        />
      ))}
    </Steps>
  )
}

export default CustomSteps
